import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../../store';
import { useTranslation } from 'react-i18next';
import { Address } from '../../common/address';
import { ErrorType } from '../../../domains/common.domain';

const ServiceAddress = observer(() => {
  const { t } = useTranslation('', { keyPrefix: 'SERVICE_ADDRESS' });
  const { serviceAddressStore: store, billingInformationStore, shippingInformationStore } = useStore();
  const { address } = store;
  const handleChange = (field: keyof typeof store.address, value: string) => {
    billingInformationStore.resetAddressType();
    shippingInformationStore.uncheckSameAsServiceAddress();
    store.updateAddress(field, value);
  };

  const setError = (field: keyof typeof store.address, error: ErrorType) => {
    store.setError(field, error);
  };

  return (
    <div className={'step'}>
      <h2>{t('TITLE')}</h2>
      <span className={'step-info'}>{t('INFO')}</span>

      <Address
        address={address}
        handleChange={handleChange}
        setError={setError}
        selectedCountry={store.selectedCountry}
        onCityNormalized={city => store.updateAddress('city', city)}
      />
    </div>
  );
});

export default ServiceAddress;
